import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ThemeProvider, AuthProvider, DataProvider } from './context';
import './i18n';
import './styles/global.css';

import Header from './components/Topbar';
import Body from './components/Body';
import Footer from './components/Footer';
import { CookieConsent, ChatWidget } from './components/Shared';
import ClickTracker from './components/ClickTracker';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppShell() {
  return (
    <>
      <ScrollToTop />
      <ClickTracker />
      <Header />
      <Body />
      <Footer />
      <ChatWidget />
      <CookieConsent />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <DataProvider>
            <AppShell />
          </DataProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
